import {axiosInstance} from "../instance";

// API MOCK -> TODO: AXIOS AND REAL API
const EmulsionTypes = new Promise((resolve, reject) => {
    const emulsionTypes = [
        {
            key: 1,
            value: 'C60B10 ZM/R',
            name: 'C60B10 ZM/R',
            percentageOfAsphalt: 60,
            order: 1
        },
        {
            key: 2,
            value: 'C60B3 ZM',
            name: 'C60B3 ZM',
            percentageOfAsphalt: 60,
            order: 2
        },
        {
            key: 3,
            value: 'C60BP3 ZM',
            name: 'C60BP3 ZM',
            percentageOfAsphalt: 60,
            order: 3
        },
        {
            key: 4,
            value: 'C65B3 PU/RC',
            name: 'C65B3 PU/RC',
            percentageOfAsphalt: 65,
            order: 4
        },
        {
            key: 5,
            value: 'C65BP3 PU/RC',
            name: 'C65BP3 PU/RC',
            percentageOfAsphalt: 65,
            order: 5
        },
        {
            key: 6,
            value: 'C69B3 PU',
            name: 'C69B3 PU',
            percentageOfAsphalt: 69,
            order: 6
        },
        {
            key: 7,
            value: 'C69BP3 PU',
            name: 'C69BP3 PU',
            percentageOfAsphalt: 69,
            order: 7
        },
        {
            key: 8,
            value: 'Mleczko wap.-bitumiczne',
            name: 'Mleczko wap.-bitumiczne',
            order: 8
        },
        {
            key: 9,
            value: 'Mleczko wap.–nie bitumiczne',
            name: 'Mleczko wap.–nie bitumiczne',
            order: 9
        },
        {
            key: 10,
            value: 'Asfalt (k.do 8cm)',
            name: 'Asfalt (k.do 8cm)',
            percentageOfAsphalt: 100,
            edgeHeight: 8,
            order: 10
        },
        {
            key: 11,
            value: 'Asfalt (k.do 16cm)',
            name: 'Asfalt (k.do 16cm)',
            percentageOfAsphalt: 100,
            edgeHeight: 16,
            order: 12
        },
        {
            key: 12,
            value: 'Asfalt(k.do 22cm)',
            name: 'Asfalt(k.do 22cm)',
            percentageOfAsphalt: 100,
            edgeHeight: 22,
            order: 14
        },
        {
            key: 13,
            value: 'Asfalt (k.do 30cm)',
            name: 'Asfalt (k.do 30cm)',
            percentageOfAsphalt: 100,
            edgeHeight: 30,
            order: 16
        },
        {
            key: 14,
            value: 'Kruszywo 2/5',
            name: 'Kruszywo 2/5',
            order: 17
        },
        {
            key: 15,
            value: 'Kruszywo 5/8',
            name: 'Kruszywo 5/8',
            order: 18
        },
        {
            key: 16,
            value: 'Asfalt(k.do 10cm)',
            name: 'Asfalt(k.do 10cm)',
            percentageOfAsphalt: 100,
            edgeHeight: 10,
            order: 11
        },
        {
            key: 17,
            value: 'Asfalt(k.do 20cm)',
            name: 'Asfalt(k.do 20cm)',
            percentageOfAsphalt: 100,
            edgeHeight: 20,
            order: 13
        },
        {
            key: 18,
            value: 'Asfalt(k.do 25cm)',
            name: 'Asfalt(k.do 25cm)',
            percentageOfAsphalt: 100,
            edgeHeight: 25,
            order: 15
        }
    ];

    resolve(emulsionTypes);
});

const InvestmentEmulsions = (investmentId) => {
    return axiosInstance.get(`/api/emulsions/${investmentId}`);
};

const InvestmentEmulsionSave = (emulsionData) => {
    return axiosInstance.post('api/emulsion/investment', emulsionData);
};

const InvestmentEmulsionsReorder = (emulsionsArr) => {
    return axiosInstance.post('/api/emulsions/reorder', emulsionsArr);
};

const InvestmentEmulsionsDelete = (emulsionId) => {
    return axiosInstance.delete(`/api/emulsion/${emulsionId}`);
};

const EmulsionInvestmentList = (id) => {
    return axiosInstance.get(`/api/emulsion/investment/${id}`);
}

const InvestmentEmulsionRecalculateAsphaltPercentage = async (investmentId) => {
    const emulsionTypes = await EmulsionTypes;
    return axiosInstance.post(`/api/emulsion/recalculate-asphalt-percentage/${investmentId}`, {emulsion_types: emulsionTypes});
}

export {
    EmulsionTypes,
    InvestmentEmulsions,
    InvestmentEmulsionsReorder,
    InvestmentEmulsionsDelete,
    EmulsionInvestmentList,
    InvestmentEmulsionSave,
    InvestmentEmulsionRecalculateAsphaltPercentage
};
